import React, { useState } from "react";
import VerifyMapExcelOutputContainer from "./../VerifyMapOutputContainer/VerifyMapExcelOutputContainer";
import { values } from "lodash";
import { get } from "lodash-es";
import { jsonToStringConverter } from "./../../../utils/constants/mapper";

const PreviewSectionForFilterCondition = ({
  valuesMain,
  editorConsoleCode,
  standard,
  values,
  stringifyFilterCollection,
  dataEditorConsoleCode,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      {standard ? (
        <div className="d-flex previewbackgroundForFilter align-items-baseline">
          <span className="ft-14 fw-500">
            Preview<span class="active-dot">●</span>
          </span>
          <div className="d-flex preview-cardfilter justify-content-between mt-3">
            <div>
              <div className="mt-1 collectionHeader">Collection</div>
              <div className="collectionValue">
                {get(valuesMain, "headerData.value.propertyNameParent")}
              </div>
            </div>

            <div>
              <div className="mt-1 collectionName">Name</div>
              <div className="collectionType">
                Value:{get(valuesMain, "headerData.value.propertyName")}
              </div>
            </div>

            <div>
              <div
                style={{
                  marginLeft: "0px",
                  borderLeft: "1px solid rgb(189, 189, 189)",
                  height: " 100%",
                }}
              />
            </div>

            <div>
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineHeight: "21px",
                  color: "#000000",
                }}
              >
                Expression
              </div>
              <div className="collectionType">
                Src-category is EE contribution
                {/* {jsonToStringConverter(valuesMain?.headerData)} */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex previewbackgroundForFilter align-items-baseline">
          <div>
            <div
              style={{
                margin: "20px 20px",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "21px",
                color: "#000000",
              }}
            >
              Expression
            </div>
            <div
              style={{
                marginTop: "-15px",
                marginLeft: "20px",
              }}
            >
              {editorConsoleCode}
              {/* {jsonToStringConverter(valuesMain?.headerData)} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewSectionForFilterCondition;
